import { render, staticRenderFns } from "./FuneralNotice.vue?vue&type=template&id=286ac0fa&scoped=true&"
import script from "./FuneralNotice.vue?vue&type=script&lang=js&"
export * from "./FuneralNotice.vue?vue&type=script&lang=js&"
import style0 from "./FuneralNotice.vue?vue&type=style&index=0&id=286ac0fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286ac0fa",
  null
  
)

export default component.exports